<template>
  <v-app id="inspire" style="background: white;">
    <Navbar/>
    <v-layout row wrap style="margin-top: 64px;" class="hidden-sm-and-down">
      <v-flex md3 lg3 xl3 style="background-color: white !important;padding: 20px;    border-right: 1px #80808021 solid;">
<div style="margin-bottom: 10px;" @click="link('')">
      <b style="color: #2662af; cursor: pointer;">
        <v-icon style="font-size: 20px !important;color: #2662af;">home</v-icon>
      Home
    </b>
</div>
        <p style="margin-bottom: 10px;font-weight: bold;">สติ๊กเกอร์</p>
      <v-layout row wrap v-for="(item,index) in listSticker" class=" stickerlist" @click="link(item.token_sticker)" :key="index">
      <v-flex md5 lg5 xl5>
          <img :src="item.path_title" style="height: 100px;" />
      </v-flex>
      <v-flex md7 lg7 xl7 style="    padding-top: 34px;">
        <span style="color: #2662af;font-size: 16px;">{{item.title_name}}</span>
      </v-flex>
    </v-layout>
      </v-flex>
      <v-flex md9 lg9 xl9 style="background-color: white !important;">
        <router-view ></router-view>
      </v-flex>
    </v-layout>

    <v-layout row wrap style="margin-top: 64px;" class="hidden-md-and-up">
      <v-flex xs12 sm12 style="background-color: white !important;padding: 20px;    border-right: 1px #80808021 solid;">
<div style="margin-bottom: 10px;" @click="link('')">
      <b style="color: #2662af; cursor: pointer;">
        <v-icon style="font-size: 20px !important;color: #2662af;">home</v-icon>
      Home
    </b>
</div>
        <p style="margin-bottom: 10px;font-weight: bold;">สติ๊กเกอร์</p>
      <v-layout row wrap v-for="(item,index_stic) in listSticker" class=" stickerlist" @click="link(item.token_sticker)" :key="index_stic">
      <v-flex md5 lg5 xl5>
          <img :src="item.path_title" style="height: 100px;" />
      </v-flex>
      <v-flex md7 lg7 xl7 style="    padding-top: 34px;">
        <span style="color: #2662af;font-size: 16px;">{{item.title_name}}</span>
      </v-flex>
    </v-layout>
      </v-flex>
      <v-flex xs12 sm12 style="background-color: white !important;">
        <router-view ></router-view>
      </v-flex>
    </v-layout>

  </v-app>
</template>

<script>
import Navbar from '@/components/home/Navbarapi'
export default {
  data: () => ({
    listSticker: [
      {
        'path_title': 'https://chat-public.one.th:8034/getmessage_sticker/bucket-sticker/S75d07738b61a535cbfaed2419e6c0116/S75d07738b61a535cbfaed2419e6c0116_2.png',
        'title_name': 'น้อง Wonder',
        'token_sticker': 'S75d07738b61a535cbfaed2419e6c0116'
      },
      {
        'path_title': 'https://chat-public.one.th:8034/getmessage_sticker/bucket-sticker/Sec7aea7dd55f5150b51702bdeb2fa093/Sec7aea7dd55f5150b51702bdeb2fa093_2.png',
        'title_name': 'น้อง Wonder ชุด HNY',
        'token_sticker': 'Sec7aea7dd55f5150b51702bdeb2fa093'
      }
    ]
  }),
  props: {
    source: String
  },
  methods: {
    link (token) {
      this.$router.push('/sticker/' + token)
    }
  },
  components: {
    Navbar
  },
  computed: {
  },
  watch: {
  },
  created () {
  }
}
</script>
<style type="text/css" scope>
  b {
    font-weight: 900 !important;

  }

.tabss{
  background-color: #1da1f2 !important;
}
.tabssright{
  background-color: #2562af !important;
}
.tabs__bar .icon--right {
    right: 10px !important;
}
.tabs__bar .icon--left {
    left: 10px !important;
}

.tabs:not(.tabs--grow):not(.tabs--mobile) .tabs__item {
    padding: 0 15px !important;
}
.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}
.text {
  white-space: nowrap;
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 10px;
  padding-top: 0px;
  font-family: 'CS ChatThaiUI' !important;
}
.textlayout {
  white-space: nowrap;
  width: 9em;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 0vw;
  padding-top: 1vh;
  padding-left: 2vw;
  font-family: 'CS ChatThaiUI' !important;
  font-size: 18px;
  padding-bottom: 0px;
  color: white;
  text-transform: none;
}
span.badge__bage.red {
  left: 27px;
}
.icon {
  font-size: 25px!important;
}
.badge--overlap .badge__badge {
  top: -12px;
  right: -9px;
}
.application .theme--light.list .list__tile:not(.list__tile--active), .theme--light .list .list__tile:not(.list__tile--active) {
  padding: 2vw !important;
}
/*.application .theme--light.list, .theme--light .list {
  padding: 2vw !important;
}*/
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.listmenuweb {
  padding-left: 8px !important;
}
.list {
  padding-left: 8px !important;
}
.stickerlist {
  cursor: pointer;
}
.stickerlist:hover {
  background: aliceblue;
}
</style>



// WEBPACK FOOTER //
// src/components/sticker/stickerhomepage.vue